import { Button, MessageBar, MessageBarBody, MessageBarTitle } from '@fluentui/react-components';

export const ErrorState = ({ message, onRetry }: { message: string; onRetry?: () => void }) => (
  <MessageBar intent="error">
    <MessageBarBody>
      <MessageBarTitle>Something went wrong</MessageBarTitle>
      {message}
      {onRetry ? <Button appearance="subtle" onClick={onRetry}>Retry</Button> : null}
    </MessageBarBody>
  </MessageBar>
);
